import { type Common } from '../common.js';
import {
  type ResourceDefinition,
  type ResourceDefinitionFindAllOptions,
  type ResourceDefinitionSummary,
} from '../models/resourceGateway/resourceDefinition.js';

export class API {
  common: Common;
  baseEndpoint = '/resource-gateway/resource-access/definitions';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    queryParams?: ResourceDefinitionFindAllOptions
  ): Promise<{ resourceDefinitions: ResourceDefinitionSummary[] }> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams ?? {});
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<{ resourceDefinition: ResourceDefinition }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }
}
